import gstyles from "@gstyles/index";
import cx from "classnames";
import styles from "./General.module.scss";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StoryArticleService/getter";
import { formatDateDisplay } from "@utils/dateFormatter";
import { useTranslationContext } from "@providers/TranslationProvider";
import _ from "lodash";
const View = () => {
  const { article } = usePageContext();
  const { i18n } = useTranslationContext();
  const counts = [getter.title(article), getter.description(article)];
  _.map(getter.details(article), (comp) => {
    !!_.isString(_.get(comp, "title")) && counts.push(_.get(comp, "title"));
    !!_.isString(_.get(comp, "text")) && counts.push(_.get(comp, "text"));
    !!_.isString(_.get(comp, "content")) && counts.push(_.get(comp, "content"));
  });
  const readingTime = _.round(
    (_.get(_.words(_.join(_.compact(counts), " ")), "length") || 0) / 300 +
      0.499
  );
  return (
    <section
      data-scroll-section
      className={cx("inner-article", styles.section)}
    >
      <h1 className={cx("ama-title", styles.title)}>
        {getter.title(article)}
      </h1>
      <div className={cx("ama-content flex justify-center", styles.group)}>
        <span>{getter.category(article).name} |</span>
        <span>{formatDateDisplay(getter.publishedAt(article))}</span>
        <span className="flex gap-1">
          {gstyles.icons({
            name: "clock-outline-1",
            size: 18,
            color: gstyles.colors["yellow-1"],
          })}
          {readingTime} {i18n.t("DateFormat.Unit.minute")}
        </span>
      </div>
    </section>
  );
};
export default View;
